export default 'team';
